import { JsonObject } from "../interface/json";

const d = window as any;
export const userService = {
  getIP(): any {
    return d.$sk.sxhr.getScript("https://api.smarket.net.cn/cityjson");
  },

  getId(info: JsonObject): Promise<any> {
    const path = "anonymous/getId";
    return d.$sk.$skxhrp(path, info);
  },

  checkSess(info: JsonObject): Promise<any> {
    const path = "anonymous/checkSess";
    return d.$sk.$skxhrp(path, info);
  },

  checkRegistration(info: JsonObject, type: string): Promise<any> {
    const path = {
      poll: "poll/tool/checkRegistration",
      customForm: "customForm/checkRegistration",
      questionary: "questionary/tool/checkRegistration",
    };
    return d.$sk.$skxhrp(path[type], info);
  },
};
